export default "__VITE_ASSET__CZDRsCLw__"